import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "_modal bg-white" }
const _hoisted_2 = { class: "_modal__content md-down:px-4 px-12 py-6 flex flex-col items-center justify-center" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div><svg fill=\"none\" height=\"61\" viewBox=\"0 0 62 61\" width=\"62\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_31881_14674)\"><path d=\"M30.8021 3.88292C16.1243 3.88292 4.18917 15.8238 4.18917 30.501C4.18917 45.1762 16.1243 57.1171 30.8021 57.1171C45.4798 57.1171 57.4202 45.1762 57.4202 30.501C57.4202 15.8238 45.4798 3.88292 30.8021 3.88292ZM30.8021 60.5C14.2628 60.5 0.799988 47.0418 0.799988 30.501C0.799988 13.9582 14.2628 0.5 30.8021 0.5C47.3465 0.5 60.8042 13.9582 60.8042 30.501C60.8042 47.0418 47.3465 60.5 30.8021 60.5Z\" fill=\"#F4C870\"></path><path d=\"M53.7054 30.5011C53.7054 43.1493 43.4521 53.4026 30.7997 53.4026C18.1525 53.4026 7.89923 43.1493 7.89923 30.5011C7.89923 17.8518 18.1525 7.59799 30.7997 7.59799C43.4521 7.59799 53.7054 17.8518 53.7054 30.5011Z\" fill=\"#F0BB4F\"></path><path clip-rule=\"evenodd\" d=\"M29.2 40.0999C29.2 40.0999 27.6 40.0999 27.6 38.4999C27.6 36.8999 29.2 32.0999 35.6 32.0999C42 32.0999 43.6 36.8999 43.6 38.4999C43.6 40.0999 42 40.0999 42 40.0999H29.2Z\" fill=\"white\" fill-rule=\"evenodd\"></path><path clip-rule=\"evenodd\" d=\"M35.6 30.4999C38.251 30.4999 40.4 28.3509 40.4 25.6999C40.4 23.0489 38.251 20.8999 35.6 20.8999C32.949 20.8999 30.8 23.0489 30.8 25.6999C30.8 28.3509 32.949 30.4999 35.6 30.4999Z\" fill=\"white\" fill-rule=\"evenodd\"></path><path clip-rule=\"evenodd\" d=\"M26.3462 40.0999C26.1209 39.6453 26 39.1065 26 38.4999C26 36.3311 27.0865 34.1007 29.0975 32.5478C28.2177 32.2664 27.1921 32.0999 26 32.0999C19.6 32.0999 18 36.8999 18 38.4999C18 40.0999 19.6 40.0999 19.6 40.0999H26.3462Z\" fill=\"white\" fill-rule=\"evenodd\"></path><path clip-rule=\"evenodd\" d=\"M25.2 30.5C27.4091 30.5 29.2 28.7091 29.2 26.5C29.2 24.2909 27.4091 22.5 25.2 22.5C22.9908 22.5 21.2 24.2909 21.2 26.5C21.2 28.7091 22.9908 30.5 25.2 30.5Z\" fill=\"white\" fill-rule=\"evenodd\"></path></g><defs><clipPath id=\"clip0_31881_14674\"><rect fill=\"white\" height=\"60\" transform=\"translate(0.799988 0.5)\" width=\"60.4\"></rect></clipPath></defs></svg></div>", 1)
const _hoisted_4 = { class: "_modal__content__title text-neutral-700 font-semibold text-2xl mt-5" }
const _hoisted_5 = { class: "text-center text-neutral-500 mt-2" }
const _hoisted_6 = {
  key: 0,
  class: "w-full"
}
const _hoisted_7 = { class: "p-6 bg-white select-tabs" }
const _hoisted_8 = { class: "flex flex-nowrap items-center" }
const _hoisted_9 = { class: "flex flex-nowrap items-center font-medium" }
const _hoisted_10 = {
  key: 1,
  class: "w-full flex items-center justify-center mb-8"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("button", {
  class: "button-p btn--ghost w-fit",
  type: "button"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2 whitespace-nowrap" }, "Tạo lớp nhóm")
], -1)
const _hoisted_12 = { class: "_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.classes.length > 0
						? 'Thay đổi lớp nhóm'
						: 'Chưa có lớp nhóm nào'), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.classes.length > 0
						? 'Bạn hãy chọn lớp nhóm từ danh sách lớp nhóm của cơ sở'
						: 'Cơ sở của bạn chưa có lớp nhóm nào'), 1)
    ]),
    (_ctx.classes.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Multiselect, {
              modelValue: _ctx.classSelected,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.classSelected) = $event)),
              "allow-empty": false,
              maxHeight: 100,
              options: 
						_ctx.classes
							?.filter(
								(s) =>
									!_ctx.classesSelected
										?.map((item) => item.id)
										.includes(s.id)
							)
							?.map((s) => {
								return {
									nameSearch: _ctx.toEnglish(s?.name),
									...s,
								};
							})
					,
              searchable: true,
              "deselect-label": "Đã chọn",
              label: "nameSearch",
              placeholder: "Chọn lớp nhớm",
              selectLabel: "",
              "track-by": "id"
            }, {
              noResult: _withCtx(() => [
                _createTextVNode(" Không tìm thấy kết quả")
              ]),
              option: _withCtx((props) => [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", null, _toDisplayString(props.option.name), 1)
                ])
              ]),
              singleLabel: _withCtx(({ option }) => [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", null, _toDisplayString(option.name), 1)
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "options"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_router_link, { to: "/group-classes" }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ])),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("button", {
        class: "button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700",
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, _toDisplayString(_ctx.classes.length > 0 ? 'Đóng' : 'Xác nhận'), 1),
      (_ctx.classes.length > 0)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "button-p text-center whitespace-nowrap",
            type: "button",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
          }, " Xác nhận "))
        : _createCommentVNode("", true)
    ])
  ]))
}